import { BooleanTransform } from '@ember-data/serializer/transform'
export default BooleanTransform
